import { render, staticRenderFns } from "./DreamBooks.vue?vue&type=template&id=4c24f24b&scoped=true&"
import script from "./DreamBooks.vue?vue&type=script&lang=js&"
export * from "./DreamBooks.vue?vue&type=script&lang=js&"
import style0 from "./DreamBooks.vue?vue&type=style&index=0&id=4c24f24b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24f24b",
  null
  
)

export default component.exports